<template>
  <kendo-multiselect
      ref="cmpyIdRef"
      id="cmpyNm"
      :data-source="this.$store.state.codeRequestStore.search.combobox.cmpyNm.data"
      :data-text-field="textField"
      :data-value-field="'cmpyId'"
      :tag-mode="'single'"
      :value="cmpyIdDataArray"
      :auto-close="false"
      @change="onChangeCmpyIdDropdownList"
      :tag-template="`<span class='k-input'>#:values.length# 회사 선택됨 </span>`"
  >
  </kendo-multiselect>
</template>

<script>
import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'

export default {
  name: 'MultiSelectCompany',
  props : {
    propsCmpyIdDataArray : {
      type : Array,
      required : false,
      default : function (){
        return []
      }
    },
  },
  watch : {
    propsCmpyIdDataArray : function (newValue, oldValue){
      this.$refs.cmpyIdRef.kendoWidget().value(newValue)
    }
  },

  updated(){
    const vm = this
    if(vm.$props.propsCmpyIdDataArray.length>1){
      vm.$refs.cmpyIdRef.kendoWidget().value(vm.propsCmpyIdDataArray)
    }else {
      vm.$refs.cmpyIdRef.kendoWidget().value(vm.cmpyIdDataArray)
    }
    vm.onChangeCmpyIdDropdownList()
  },

  methods: {
    onChangeCmpyIdDropdownList () {
      const vm = this
      let data = {
        cmpyId: vm.$refs.cmpyIdRef.kendoWidget().value(),
        cmpyArray: vm.$refs.cmpyIdRef.kendoWidget().dataItems(),
      }
      vm.$emit('on-change-multi-dropdown-company', data)
    },
  },
  data () {
    return {
      textField: 'cmpyNm',
      cmpyIdDataArray: [],
    }
  },
}
</script>

<style scoped>
#cmpyNm_taglist{
  width:100%;
  align-items:center;
}
#cmpyNm_taglist li{
  margin:0 0 0 0px;
}
</style>
